import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import LibraryApiCall from 'LibraryApiCall';
import config from 'config';
import React, { useEffect, useState } from 'react';
import { ToastContainer, toast } from "react-toastify";
import TableSkeleton from '../TableSkeleton/TableSkeleton';
import 'LIBRARY/CommonResources/SpecificUserLog/SpecificUserLog.css';
import Pagination from 'react-js-pagination';

const SpecificUserLog = ({ showSlider, closeSlider, logUid, activityArr }) => {
    const [logs, setLogs] = useState({});
    const [loadingLogs, setLoadingLogs] = useState(false);
    const [sortedLogs, setSortedLogs] = useState([]);

    // Pagination states
    const [userActivityPageIndex, setUserActivityPageIndex] = useState(1);
    const [userActivityLimit, setUserActivityLimit] = useState(10);
    const [userActivityTotalCount, setUserActivityTotalCount] = useState(0);

    useEffect(() => {
        apiCallToGetLogs();
    }, [userActivityPageIndex, userActivityLimit]); // Re-fetch when page or limit changes

    const apiCallToGetLogs = async () => {
        setLoadingLogs(true);
        const requestData = {
            iid: config.institute_id,
            user_role: "employee",
            user_id: '',
            // user_id: config.faculty_id,
            activity_unique_id: logUid,
            activity_key_array: activityArr,
            module_id: 23,
            limit: userActivityLimit,
            page_index:userActivityPageIndex,
            // offset: (userActivityPageIndex - 1) * userActivityLimit
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetUserActivityLogs',
            requestData,
            "/api/user_activity_logs.php",
        );

        if (jsonResponse.expired) {
            setTimeout(() => apiCallToGetLogs(), 1000);
        } else {
            if (jsonResponse.success) {
                const apiResult = jsonResponse.APIResult.data;
                setLogs(apiResult);
                setSortedLogs(jsonResponse.APIResult.sortedIdArray);
                setUserActivityTotalCount(jsonResponse.APIResult.total || Object.keys(apiResult).length);
            } else {
                toast.error(`${jsonResponse.APIResult.message}`, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            }
            setLoadingLogs(false);
        }
    };

    const handlePageChange = (pageNumber) => {
        setUserActivityPageIndex(pageNumber);
    };

    const handleLimitChange = (e) => {
        setUserActivityLimit(Number(e.target.value));
        setUserActivityPageIndex(1); // reset to first page
    };

    return (
        <>
            <div id="addLeavesSlider" style={{ display: showSlider ? 'flex' : 'none' }}>
                <div id="addLeavesDataContainer">
                    <div id="addLeavesHeader" className="row">
                        <FontAwesomeIcon
                            icon={['fas', 'times']}
                            size="sm"
                            style={{ color: "#5F6368", cursor: "pointer" }}
                            onClick={() => closeSlider()}
                        />
                        <h5 className="col-11 ml-2">Activities</h5>
                    </div>
                    <div id="addLeavesBody" className="col-md-12">
                        {loadingLogs ? (
                            <TableSkeleton />
                        ) : Object.values(logs).length > 0 ? (
                            <table className='table table-bordered mb-0'>
                                <thead>
                                    <tr style={{ position: "sticky", top: "0", backgroundColor: "#F5F8FA" }}>
                                        <th className='fs-11' style={{ padding: "5px" }}>Sr. No.</th>
                                        <th className='fs-11' style={{ padding: "5px" }}>Title</th>
                                        <th className='fs-11' style={{ padding: "5px" }}>Date And Time</th>
                                        <th className='fs-11' style={{ padding: "5px" }}>Operation</th>
                                        <th className='fs-11' style={{ padding: "5px" }}>Faculty</th>
                                    </tr>
                                </thead>
                                    <tbody>
                                        {sortedLogs.map((id, i) => {
                                            const lg = logs[id]; // pick log by id in correct order
                                            return (
                                                <tr key={id}>
                                                    <td className='fs-11' style={{ padding: "5px" }}>{i + 1 + (userActivityPageIndex - 1) * userActivityLimit}</td>
                                                    <td className='fs-11' style={{ padding: "5px" }}>{lg.action_performed}</td>
                                                    <td className='fs-11' style={{ padding: "5px" }}>{lg.addedOn}</td>
                                                    <td className='fs-11' style={{ padding: "5px", textTransform: "capitalize" }}>{lg.operation}</td>
                                                    <td className='fs-11' style={{ padding: "5px" }}>{lg.userName}</td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                            </table>
                        ) : (
                            <p className='fs-11'>Logs not available.</p>
                        )}


                        {/* Pagination */}
                        {sortedLogs.length > 0 && (
                            <div className='paginationDesign' style={{ backgroundColor: '#eef1f4'}}>
                                <div className="perPageSelectContainer" style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                    <select value={userActivityLimit} onChange={handleLimitChange} className="enteriesPage">
                                        <option value={10}>Entries per page 10</option>
                                        <option value={25}>Entries per page 25</option>
                                        <option value={40}>Entries per page 40</option>
                                        <option value={100}>Entries per page 100</option>
                                        <option value={250}>Entries per page 250</option>
                                    </select>
                                </div>
                                <div id="paginationContainer" style={{ display: 'flex', alignItems: 'center', padding: '4px', borderRadius: '4px' }}>
                                    <Pagination
                                        activePage={userActivityPageIndex}
                                        itemsCountPerPage={userActivityLimit}
                                        totalItemsCount={userActivityTotalCount}
                                        pageRangeDisplayed={3}
                                        onChange={handlePageChange}
                                    />
                                </div>
                                <div className="customFont">
                                    <span className="customFontRecords">{`Total Records : ${userActivityTotalCount}`}</span>
                                </div>
                            </div>
                        )}


                    </div>


                </div>
            </div>
        </>
    );
};

export default SpecificUserLog;